module.exports = __webpack_public_path__ + "static/media/KaTeX_Fraktur-Regular.c5b430bf.woff";